import React from 'react';
import { TrackingLocation } from 'tracking';

import useEventTracking from '@hooks/useEventTracking';

import { FooterProps } from '.';
import FormAndSocial from './FormAndSocial';
import Links from './Links';

const FooterContent = ({
  analytics,
  currentUserLoggedin,
  hideForm,
  isPro,
  isSubscriber,
  leadDetails,
  subscribePathWithPossibleOffer,
}: FooterProps) => {
  const { Track } = useEventTracking({ ...analytics, location: TrackingLocation.Footer });

  return (
    <Track>
      <footer className="w-full bg-grayscale-charcoal px-16 py-64 sm:px-28 sm:py-80" id="ti-footer">
        <div className="m-auto flex max-w-container-lg flex-wrap justify-between">
          <Links />
          <FormAndSocial
            currentUserLoggedin={currentUserLoggedin}
            hideForm={hideForm}
            isPro={isPro}
            isSubscriber={isSubscriber}
            leadDetails={leadDetails}
            subscribePathWithPossibleOffer={subscribePathWithPossibleOffer}
          />
        </div>
      </footer>
    </Track>
  );
};

export default FooterContent;
